
import Vue from "vue";
import HeaderDropDownFilter, { OptionItem } from "@/components/BaseHeaderDropDownFilter.vue";

export type FilterCondition = {
  alertType?: string;
  toiletType?: string;
};

export type DataType = {
  filterCondition: FilterCondition;
  alertTypeOptions: Array<OptionItem>;
  toiletTypeOptions: Array<OptionItem>;
};

export default Vue.extend({
  name: "ToiletListHeader",

  components: {
    HeaderDropDownFilter,
  },

  data(): DataType {
    return {
      filterCondition: {
        alertType: undefined,
        toiletType: undefined,
      },
      alertTypeOptions: [
        {
          label: "ドアセンサ-V1",
          value: "door-v1",
        },
        {
          label: "ドアセンサ-V2",
          value: "door-v2",
        },
        {
          label: "ドアセンサ-R1",
          value: "door-r1",
        },
        {
          label: "人感センサ-V1",
          value: "infrared-v1",
        },
        {
          label: "人感センサ-R1",
          value: "infrared-r1",
        },
        {
          label: "距離センサ",
          value: "distance",
        },
        {
          label: "サーモセンサー",
          value: "thermopile",
        },
        {
          label: "MIC",
          value: "mic",
        },
        {
          label: "センサ電池",
          value: "low-battery",
        },
        {
          label: "GW",
          value: "gw",
        },
      ],
      toiletTypeOptions: [
        {
          label: "女性トイレ",
          value: "FOR_WOMAN",
        },
        {
          label: "男性トイレ",
          value: "FOR_MAN",
        },
        {
          label: "多目的トイレ",
          value: "MULTI_PURPOSE",
        },
        {
          label: "共用",
          value: "UNISEX",
        },
      ],
    };
  },

  methods: {
    updateFilterConditionAndSearch(): void {
      this.$emit("update-filter-condition", this.filterCondition);
      this.$emit("search");
    },
  },
});
